export default __webpack_public_path__ + "static/media/redTheme-girl.e2b9dd83.svg";